const it = {
  nav: {
    home: "Home",
    about: "Chi Siamo",
    destinations: "Destinazioni",
    tours: "Tour e Pacchetti",
    gallery: "Galleria",
    testimonials: "Testimonianze",
    blog: "Blog",
    contact: "Contattaci",
    experiences: "Esperienze",
    vip: "VIP Business",
    vipFull: "Viaggi d'Affari VIP",
    worldcup: "Coppa del Mondo 2030",
    jewishHeritage: "Viaggi Kosher",
    menu: "Menu",
    chatWhatsApp: "Chatta su WhatsApp"
  },
  hero: {
    welcome: "Benvenuti in Marocco.",
    welcomeHome: "Benvenuti a Casa.",
    subtitle: "Tour privati di lusso, esperienze autentiche,",
    subtitleLine2: "e servizio personale completo in tutto il Marocco —",
    subtitleGold: "gestito personalmente dal CEO.",
    whatsappBtn: "Chatta Ora con Ilan (CEO) su WhatsApp",
    badgeFast: "Risposta rapida",
    badgePersonal: "Servizio personale",
    badge247: "Disponibilità 24/7",
    limitedAvail: "Disponibilità limitata",
    personalizedOnly: "Solo viaggi personalizzati"
  },
  strip: {
    privateTours: "Tour Privati",
    localExperts: "Esperti Locali",
    bestHotels: "I Migliori Hotel",
    luxuryTransport: "Trasporto di Lusso",
    satisfaction: "Soddisfazione al 100%"
  },
  cta: {
    whatsapp: "Chatta Ora con Ilan (CEO) su WhatsApp",
    whatsappFloating: "Chatta su WhatsApp",
    whatsappInquiry: "Ciao, sono interessato a un'esperienza di viaggio premium in Marocco."
  },
  home: {
    vipBannerTitle: "Esperienze di Viaggio VIP in Marocco",
    vipBannerText: "Accesso esclusivo, autisti privati e alloggi di lusso per viaggiatori esigenti.",
    vipBannerBtn: "Scopri i Servizi VIP",
    wcBadge: "🇲🇦 Marocco Coppa del Mondo 2030",
    wcTitle: "Marocco 2030",
    wcText: "Pacchetti viaggio esclusivi per la Coppa del Mondo che combinano calcio, cultura marocchina, ospitalità VIP ed esperienze di lusso.",
    wcBtn: "Visualizza i Pacchetti",
    galleryTitle: "Galleria",
    gallerySubtitle: "Un assaggio del tuo futuro viaggio in Marocco",
    exploreDestination: "Esplora la destinazione",
    featuredToursTitle: "Tour e Pacchetti in Evidenza",
    featuredToursSubtitle: "Esperienze curate con attenzione per la perfetta avventura in Marocco",
    viewAllTours: "Visualizza Tutti i Tour",
    culinaryTitle: "Il Nostro Cibo - Il Migliore al Mondo",
    culinarySubtitle: "Sperimenta l'eccellenza culinaria marocchina 🍲",
    culinaryBtn: "Scopri le Esperienze Culinarie",
    culinaryIntro: "Presso Morocco Loves You, mangiare non è solo nutrirsi. È un viaggio nel cuore della cultura marocchina. Offriamo esperienze culinarie autentiche e selezionate — dai piatti tradizionali fatti in casa all'alta gastronomia marocchina, il tutto preparato con amore e gli ingredienti locali più freschi.",
    videoTitle: "RACCOMANDAZIONI",
    unityQuote: "Morocco Loves You accoglie tutte le culture, tutte le credenze e tutti i popoli.",
    unityAlt: "Morocco Loves You Banner dell'Unità",
    testimonialsTitle: "Cosa Dicono i Nostri Ospiti VIP",
    testimonialsSubtitle: "Recensioni reali da viaggiatori internazionali",
    readMoreReviews: "Leggi Altre Recensioni",
    viewAllTransport: "Visualizza tutti i trasporti",
    transportTitle: "Il nostro trasporto e autisti VIP",
    transportSubtitle: "Lusso, comfort e sicurezza in tutto il Marocco 🌍",
    transportIntro: "Presso Morocco Loves You, il trasporto non è solo spostarsi da un luogo all'altro. Fa parte dell'esperienza. Forniamo veicoli moderni, puliti, confortevoli e completamente climatizzati in tutto il Marocco — con autisti professionisti, calda ospitalità e servizio VIP fin dal primo momento."
  },
  tours: {
    pageTitle: "Tour e Pacchetti",
    pageSubtitle: "Scegli tra i nostri pacchetti viaggio in Marocco accuratamente selezionati",
    sectionTitle: "I Nostri Pacchetti Viaggio",
    sectionIntro: "Dalle avventure nel deserto alle fughe sulla costa, abbiamo il pacchetto perfetto per ogni viaggiatore",
    howToBook: "Come Prenotare",
    step1Title: "Scegli un Tour",
    step1Text: "Esplora i nostri pacchetti e seleziona quello che fa per te",
    step2Title: "Clicca su Prenota Ora",
    step2Text: 'Clicca sul pulsante "Prenota Ora" del tour scelto',
    step3Title: "Inserisci i Dettagli",
    step3Text: "Fornisci le date del viaggio e le tue informazioni personali",
    step4Title: "Conferma",
    step4Text: "Ricevi la conferma e i dettagli dell'itinerario via email",
    customTitle: "Hai bisogno di un pacchetto personalizzato?",
    customText: "Contattaci per creare un'esperienza di viaggio in Marocco su misura",
    customBtn: "Contattaci",
    days: "Giorni",
    highlights: "Punti salienti:",
    bookNow: "Prenota Ora",
    highlightsLabel: "PUNTI SALIENTI:",
    viewFullDetails: "Vedi Tutti i Dettagli",
    premiumMoroccoPackages: "Pacchetti Premium Marocco",
    premiumMoroccoPackagesDesc: "Esperienze esclusive e accuratamente selezionate per i nostri ospiti più esigenti.",
    pkg1: {
      title: "Fuga di Lusso Weekend Europa/Marocco",
      duration: "3 Notti / 4 Giorni",
      price: "€790",
      hl1: "Voli diretti andata e ritorno inclusi (Londra/Europa)",
      hl2: "Hotel di lusso 4-5 stelle",
      hl3: "Hammam marocchino tradizionale",
      hl4: "Workshop di cucina e arte",
      hl5: "Spettacoli marocchini dal vivo"
    },
    pkg2: {
      title: "Tour di Lusso alla Scoperta del Marocco",
      duration: "6 Notti / 7 Giorni",
      price: "€1490",
      hl1: "Pacchetto A",
      hl2: "Movimenti dell'Atlante",
      hl3: "Marrakech - Essaouira - Merzouga - Ouarzazate - Marrakech",
      hl4: "Grande sorpresa ❤️",
      hl5: "Pacchetto B"
    },
    pkg3: {
      title: "Grande Esperienza del Marocco",
      duration: "10 Notti / 11 Giorni",
      price: "€1990",
      hl1: "Servizi premium completi a terra",
      hl2: "Casablanca, Marrakech e Fes",
      hl3: "Agadir e sorprese nel deserto del Sahara",
      hl4: "Visita Ouarzazate e Chefchaouen",
      hl5: "Musica e spettacoli dal vivo speciali"
    },
    pkg4: {
      title: "ESPERIENZA DI LUSSO IN MAROCCO",
      duration: "16 Notti / 17 Giorni",
      price: "Tutto incluso",
      hl1: "Casablanca • Rabat • Fes • Tangeri • Chefchaouen",
      hl2: "Ifrane • Deserto del Sahara a Merzouga",
      hl3: "Essaouira • Ourika e Monti dell'Atlante • Marrakech",
      hl4: "2 notti in campo desertico di lusso con tour in cammello e jeep",
      hl5: "Alba e tramonto magici • Dormire sotto le stelle"
    }
  },
  destinations: {
    pageTitle: "Esplora le Destinazioni del Marocco",
    pageSubtitle: "Scopri luoghi incredibili da visitare in tutto il bellissimo Marocco",
    sectionTitle: "Tutte le Destinazioni",
    sectionIntro: "Il Marocco è un paese con paesaggi diversificati e un ricco patrimonio culturale. Esplora le nostre destinazioni accuratamente selezionate:",
    exploreNow: "Esplora Ora",
    ctaTitle: "Pronto a Pianificare il Tuo Viaggio?",
    ctaText: "Esplora i nostri tour e pacchetti curati per trovare la perfetta esperienza marocchina",
    ctaBtn: "Visualizza Tour e Pacchetti"
  },
  experiences: {
    pageTitle: "Eccellenza Culinaria Marocchina",
    pageSubtitle: "Scopri il nostro cibo — il migliore al mondo",
    bookViaWhatsApp: "Prenota tramite WhatsApp"
  },
  vip: {
    pageTitle: "Viaggi VIP e d'Affari",
    pageSubtitle: "Servizi esclusivi per CEO, investitori e viaggiatori esigenti",
    introTitle: "Eccellenza Perfetta in Marocco",
    introText: "MoroccoLovesYou offre uno standard di servizio senza pari per viaggiatori d'affari, delegazioni aziendali e ospiti VIP. Sappiamo che il tuo tempo è prezioso e i tuoi standard sono intransigenti.",
    ctaTitle: "Accesso Diretto al CEO",
    ctaText: "Per richieste urgenti e altamente specializzate, parla direttamente con il nostro Fondatore e CEO, Ilan Hatchuel.",
    ctaBtn: "Contatta Ilan Ora",
    luxuryTransport: "Trasporto di Lusso",
    luxuryTransportDesc: "Trasferimenti aeroportuali VIP e autisti privati bilingui disponibili 24/7 con veicoli di lusso (Mercedes Classe S, Classe V).",
    premiumAccom: "Alloggi Premium",
    premiumAccomDesc: "Prenotazioni esclusive in hotel a 5 stelle, riad di lusso o ville private adatte per i dirigenti.",
    businessConcierge: "Concierge Aziendale",
    businessConciergeDesc: "Assistenza completa per riunioni, prenotazioni di cene private e itinerari specializzati per ritiri aziendali.",
    securityPrivacy: "Sicurezza e Privacy",
    securityPrivacyDesc: "Servizio discreto, ambienti sicuri e assoluta riservatezza per individui di alto profilo.",
    support247: "Supporto 24/7",
    support247Desc: "Contatto diretto con il CEO e un team dedicato pronto ad assisterti in qualsiasi momento.",
    customItineraries: "Itinerari Personalizzati",
    customItinerariesDesc: "Piani di viaggio su misura che bilanciano perfettamente i tuoi impegni di lavoro con esperienze culturali marocchine di alto livello."
  },
  worldcup: {
    pageTitle: "Coppa del Mondo Marocco 2030",
    pageSubtitle: "Pacchetti VIP Esclusivi e Viaggi per il più grande Evento Calcistico",
    limitedBadge: "Disponibilità Limitata",
    introTitle: "Il Viaggio Calcistico Definitivo",
    introText: "Nel 2030, il Marocco co-ospiterà la Coppa del Mondo FIFA. MoroccoLovesYou è orgogliosa di offrire pacchetti di viaggio di lusso esclusivi e all-inclusive progettati per i fan che esigono il meglio in termini di comfort e accesso.",
    packagesTitle: "Pacchetti Premium per la Coppa del Mondo",
    silverTitle: "Pacchetto Argento",
    silverSub: "L'Esperienza Essenziale",
    goldTitle: "Pacchetto Oro",
    goldSub: "L'Esperienza di Lusso",
    mostPopular: "Più Popolare",
    diamondTitle: "Diamante VIP",
    diamondSub: "L'Esperienza Definitiva",
    inquireWhatsApp: "Richiedi tramite WhatsApp",
    ctaTitle: "Assicurati il Tuo Posto Prima dell'Aumento dei Prezzi",
    ctaText: "A causa della domanda internazionale estremamente alta, consigliamo vivamente di prenotare il tuo pacchetto VIP in anticipo.",
    ctaBtn: "Contattaci Oggi",
    silverF1: "Alloggio in Riad Premium / Hotel 4 Stelle",
    silverF2: "Logistica Pre-pianificata per il Giorno della Partita",
    silverF3: "Tour Guidati della Città",
    silverF4: "Linea di Supporto Dedicata 24/7",
    goldF1: "Alloggio in Hotel 5 Stelle / Villa di Lusso",
    goldF2: "Trasferimenti Privati Aeroporto & Partite",
    goldF3: "Fuga nel Campo nel Deserto VIP (2 Giorni)",
    goldF4: "Concierge Personale Bilingue",
    diamondF1: "Suite Presidenziali / Palazzi Privati",
    diamondF2: "Autista Privato e Sicurezza 24/7",
    diamondF3: "Accesso Esclusivo a Eventi VIP",
    diamondF4: "Gestione Diretta del CEO e Concierge VVIP"
  },
  gallery: {
    pageTitle: "La Nostra Galleria",
    pageSubtitle: "Ricordi visivi di indimenticabili viaggi in Marocco",
    picturesTitle: "Il Marocco in Immagini",
    picturesIntro: "Esplora la nostra collezione di foto mozzafiato del Marocco",
    videosTitle: "Il Marocco in Movimento",
    videosIntro: "Vivi il Marocco attraverso la nostra curata collezione di video"
  },
  testimonials: {
    pageTitle: "Testimonianze degli Ospiti",
    pageSubtitle: "Leggi cosa dicono i nostri viaggiatori della loro esperienza in Marocco",
    sectionTitle: "I Nostri Viaggiatori Felici",
    sectionIntro: "Migliaia di ospiti soddisfatti hanno vissuto la magia del Marocco con noi",
    verifiedGuest: "Ospite Verificato",
    ratingsTitle: "Le Nostre Valutazioni",
    avgRating: "Valutazione Media",
    verifiedReviews: "Recensioni Verificate",
    fromReal: "Da veri viaggiatori",
    custSatisfaction: "Soddisfazione del Cliente",
    wouldRecommend: "Lo raccomanderei",
    shareTitle: "Condividi la Tua Esperienza",
    shareText: "Hai fatto un viaggio fantastico con noi? Ci piacerebbe saperlo!",
    shareBtn: "Raccontaci la Tua Storia"
  },
  blog: {
    pageTitle: "Blog di Viaggio",
    pageSubtitle: "Storie, suggerimenti e guide per la tua avventura in Marocco",
    sectionTitle: "Ultimi Articoli di Viaggio",
    sectionIntro: "Leggi i nostri ultimi articoli sui viaggi in Marocco, sulla cultura locale e sui consigli degli esperti",
    readMore: "Leggi di Più →",
    by: "Di",
    newsletterTitle: "Iscriviti alla Nostra Newsletter",
    newsletterText: "Ricevi gli ultimi consigli di viaggio e le offerte esclusive nella tua casella di posta",
    newsletterPlaceholder: "Inserisci la tua email",
    subscribe: "Iscriviti"
  },
  contact: {
    pageTitle: "Contattaci",
    pageSubtitle: "Mettiti in contatto con il nostro team per pianificare la tua avventura VIP in Marocco",
    getInTouch: "Mettiti in Contatto",
    getInTouchText: "Siamo qui per aiutarti e rispondere a tutte le tue domande. Il nostro team è pronto ad assisterti nella pianificazione del tuo viaggio perfetto in Marocco.",
    address: "Indirizzo",
    phone: "Telefono",
    email: "Email",
    businessHours: "Orari di Apertura",
    businessHoursText: "Lunedì - Venerdì: 9:00 - 18:00\nSabato: 10:00 - 16:00\nDomenica: Chiuso",
    followUs: "Seguici",
    formTitle: "Inviaci un Messaggio",
    successMessage: "✓ Grazie! Ti risponderemo presto.",
    fullName: "Nome Completo",
    emailAddress: "Indirizzo Email",
    phoneNumber: "Numero di Telefono",
    subject: "Oggetto",
    selectSubject: "Seleziona un oggetto",
    tourInquiry: "Richiesta Tour",
    bookingQuestion: "Domanda di Prenotazione",
    customPackage: "Pacchetto Personalizzato",
    feedback: "Feedback",
    other: "Altro",
    message: "Messaggio",
    sendMessage: "Invia Messaggio",
    mapTitle: "Trovaci sulla Mappa",
    faqTitle: "Domande Frequenti",
    faq1Q: "Qual è il periodo migliore per visitare il Marocco?",
    faq1A: "La primavera (aprile-maggio) e l'autunno (settembre-ottobre) offrono il clima migliore.",
    faq2Q: "Ho bisogno di un visto per visitare il Marocco?",
    faq2A: "I requisiti del visto dipendono dalla tua nazionalità. Molti paesi hanno un ingresso senza visto fino a 90 giorni.",
    faq3Q: "Che valuta viene utilizzata in Marocco?",
    faq3A: "Il Dirham marocchino (MAD) è la valuta ufficiale.",
    faq4Q: "Che lingua si parla in Marocco?",
    faq4A: "L'arabo e il berbero sono le lingue ufficiali. Il francese è ampiamente parlato.",
    faq5Q: "Il Marocco è sicuro per i turisti?",
    faq5A: "Sì, il Marocco è generalmente sicuro. Le nostre guide assicurano un'esperienza sicura.",
    faq6Q: "Posso personalizzare il mio pacchetto turistico?",
    faq6A: "Assolutamente! Offriamo pacchetti personalizzati. Contattaci."
  },
  about: {
    pageTitle: "Chi Siamo - MoroccoLovesYou",
    pageSubtitle: "Il tuo partner di fiducia nella scoperta della magia del Marocco",
    storyTitle: "La Nostra Storia",
    storyP1: "MoroccoLovesYou è stata fondata con una semplice missione: aiutare i viaggiatori a vivere l'autentica bellezza e ospitalità del Marocco.",
    storyP2: "La nostra fondatrice si innamorò del Marocco e volle condividere questa passione con il mondo.",
    missionTitle: "🎯 La Nostra Missione",
    missionText: "Fornire esperienze di viaggio eccezionali che mostrino il ricco patrimonio culturale del Marocco.",
    visionTitle: "🌟 La Nostra Visione",
    visionText: "Essere l'azienda leader nel turismo in Marocco nota per autenticità e affidabilità.",
    whyTitle: "Perché Scegliere MoroccoLovesYou?",
    expertTitle: "Conoscenza Esperta",
    expertText: "Il nostro team ha una vasta conoscenza del Marocco.",
    localTitle: "Connessioni Locali",
    localText: "Lavoriamo con autentiche guide e famiglie locali.",
    valueTitle: "Il Miglior Valore",
    valueText: "Prezzi competitivi senza compromettere la qualità.",
    safetyTitle: "Sicurezza e Supporto",
    safetyText: "Supporto clienti 24/7 e assicurazione di viaggio completa inclusa.",
    sustainTitle: "Turismo Sostenibile",
    sustainText: "Supportiamo le comunità locali e pratichiamo un turismo responsabile.",
    bookingTitle: "Prenotazione Facile",
    bookingText: "Processo di prenotazione online semplice con opzioni di pagamento flessibili.",
    teamTitle: "Il Nostro Team",
    teamSubtitle: "Incontra le persone appassionate dietro MoroccoLovesYou",
    happyTravelers: "Viaggiatori Felici",
    yearsExp: "Anni di Esperienza",
    destinationsCount: "Destinazioni",
    satisfactionRate: "Tasso di Soddisfazione"
  },
  footer: {
    description: "Scopri la magia del Marocco con noi. Vivi avventure indimenticabili.",
    quickLinks: "Link Rapidi",
    more: "Altro",
    contactInfo: "Informazioni di Contatto",
    copyright: "© 2024 MoroccoLovesYou. Tutti i diritti riservati."
  },
  starBanner: {
    ceoMessage: "MESSAGGIO DEL CEO",
    watchVideo: "Guarda il mio video",
    readMessage: "& leggi il mio messaggio",
    getToKnow: "Conosci",
    ilanPersonally: "Ilan personalmente"
  },
  tourMini: {
    days: "10 GIORNI",
    nights: "/ 9 NOTTI",
    title: "TOUR PREMIUM\nMAROCCO",
    years: "2026 - 2027",
    departures: "PARTENZE MENSILI",
    allIncluded: "TUTTO INCLUSO\nPENSIONE COMPLETA",
    recommendations: "Raccomandazioni",
    recCount: "500+ viaggiatori felici"
  },
  cityDetail: {
    notFound: "Città non trovata",
    backHome: "Torna alla Home",
    discoverSubtitle: "Scopri la bellezza e la cultura",
    planTrip: "Pianifica il Mio Viaggio per",
    galleryOf: "Galleria di",
    bookExperience: "Prenota Questa Esperienza",
    requestItinerary: "Richiedi L'itinerario Completo",
    readyToVisit: "Pronto per Visitare",
    readyToVisitText: "Lascia che pianifichiamo il tuo viaggio perfetto in questa fantastica destinazione",
    planMyTrip: "Pianifica il Mio Viaggio",
    talkExpert: "Parla con un Esperto"
  },
  transportation: {
    pageTitle: "Trasporto VIP e Autisti",
    pageSubtitle: "Lusso, Comfort e Sicurezza in tutto il Marocco",
    introTitle: "Il nostro trasporto e autisti VIP",
    introP1: "Presso Morocco Loves You, il trasporto non è solo spostarsi da un luogo all'altro.",
    introP2: "Fa parte dell'esperienza.",
    introP3: "Forniamo veicoli moderni, puliti, confortevoli e completamente climatizzati in tutto il Marocco — con autisti professionisti, calda ospitalità e servizio VIP fin dal primo momento.",
    introP4: "Che tu viaggi in coppia, in famiglia, come delegazione d'affari o in un gruppo privato, ci assicuriamo che il tuo viaggio sia sicuro, rilassante e indimenticabile.",
    servicesTitle: "I nostri servizi di trasporto includono",
    servicesList: [
      "Autobus VIP moderni",
      "Minibus di lusso",
      "Auto private",
      "Jeep 4x4 per avventure nel deserto",
      "Limousine VIP",
      "Ritiro e riconsegna in aeroporto",
      "Autisti professionisti multilingue",
      "Aria condizionata confortevole",
      "Veicoli puliti e organizzati",
      "Frigoriferi in veicoli selezionati",
      "Sistemi TV e intrattenimento",
      "Musica durante il viaggio",
      "Guida sicura e fluida",
      "Assistenza 24/7 in tutto il Marocco"
    ],
    driversTitle: "Incontra i nostri autisti",
    driversText1: "I nostri autisti fanno parte della famiglia Morocco Loves You.",
    driversText2: "Professionali, rispettosi, esperti e sempre pronti ad aiutare con un sorriso.",
    driversText3: "Molti dei nostri autisti parlano più lingue e conoscono profondamente il Marocco, aiutando i nostri ospiti a sentirsi a proprio agio, sicuri e connessi durante tutto il viaggio.",
    safetyTitle: "Sicurezza e comfort prima di tutto",
    safetyText1: "La tua comodità e la tua sicurezza sono le nostre massime priorità.",
    safetyText2: "Tutti i veicoli sono regolarmente manutenuti, puliti e preparati con cura prima di ogni viaggio.",
    safetyText3: "Lavoriamo solo con autisti professionisti di fiducia e partner di trasporto di alta qualità.",
    categories: {
      buses: "Autobus VIP",
      minibuses: "Minibus di lusso",
      cars: "Auto private e trasferimenti VIP",
      jeeps: "Jeep 4x4 e trasporto nel deserto",
      meetDrivers: "Incontra i nostri autisti",
      videos: "Video dell'esperienza di trasporto"
    },
    videoGalleryTitle: "Video dell'esperienza VIP",
    ctaTitle: "Pronto a esplorare il Marocco in tutta comodità?",
    ctaSubtitle: "Parla direttamente con Allan – CEO e fondatore",
    whatsapp: "WhatsApp: +972546338757",
    moroccoLine: "Linea diretta Marocco: +212 6 63 63 05 79"
  },
  jewishHeritage: {
    pageTitle: "Tour Kosher di Lusso in Marocco",
    pageSubtitle: "Autentico patrimonio ebraico, cucina 100% kosher, ospitalità di lusso ed esperienze uniche in Marocco.",
    introTitle: "Esperienza di Lusso del Patrimonio Ebraico",
    introHeading: "Scopri l’autentico Marocco ebraico",
    introText: "Scopri le profonde radici della storia ebraica in Marocco con un’esperienza di viaggio elegante, autentica e premium. Offriamo alle comunità ebraiche di tutto il mondo un viaggio impeccabile, centrato su patrimonio, connessione e comfort assoluto.",
    introQuote: "“Il Marocco è una terra di tolleranza e convivenza, dove il patrimonio ebraico è preservato con amore e rispetto.”",
    experiencesTitle: "Le nostre esperienze kosher includono",
    experiencesList: [
      "Cibo e ristoranti 100% kosher",
      "Chef kosher privato disponibile",
      "Cucina tradizionale ebraico-marocchina",
      "Hotel di lusso 4 e 5 stelle",
      "Trasporto VIP privato",
      "Guide professionali multilingue",
      "Tour del patrimonio ebraico e delle sinagoghe"
    ],
    expFood: "Cibo 100% kosher",
    expRestaurant: "Ristorante kosher",
    expChef: "Chef kosher privato disponibile",
    expCuisine: "Cucina tradizionale ebraico-marocchina",
    expHotels: "Hotel di lusso 4 e 5 stelle",
    expDeluxeHotels: "Hotel deluxe disponibili su richiesta",
    expTransport: "Trasporto VIP privato",
    expDrivers: "Autisti professionisti",
    expAC: "Veicoli climatizzati",
    expWifi: "WiFi, TV e frigoriferi in veicoli selezionati",
    expGuides: "Guide professionali multilingue",
    expStaff: "Staff che parla ebraico / inglese / francese / spagnolo / russo / tedesco",
    expHeritage: "Tour del patrimonio ebraico",
    expSynagogues: "Antiche sinagoghe",
    expCemeteries: "Cimiteri ebraici",
    expMuseums: "Musei ebraici",
    expSpiritual: "Esperienze spirituali e culturali",
    expDesert: "Esperienze nel deserto del Sahara",
    expHammam: "Esperienze hammam marocchine",
    expAttractions: "Attrazioni uniche in tutto il Marocco",
    expAssistance: "Assistenza 24/7",
    packagesTitle: "Pacchetti di viaggio kosher flessibili",
    packagesIntro: "Personalizziamo ogni viaggio secondo esigenze, tradizioni, stile di viaggio, date e aspettative dei nostri ospiti.",
    package4_5: "4-5 giorni",
    package7_8: "7-8 giorni",
    package10_11: "10-11 giorni",
    package13_14: "13-14 giorni",
    package21: "21 giorni",
    packageTailor: "Tour privati su misura",
    packagesQuote: "“Personalizziamo ogni viaggio secondo esigenze, tradizioni, stile di viaggio, date e aspettative dei nostri ospiti.”",
    safetyTitle: "Viaggi comodi, professionali e sicuri",
    safetyQuote: "“I nostri tour operano con grande attenzione a comfort, organizzazione, qualità del servizio e coordinamento professionale in tutto il Marocco.”",
    b2bTitle: "Partnership B2B per viaggi ebraici",
    b2bText: "Collaboriamo con comunità ebraiche, sinagoghe, rabbini e operatori kosher in tutto il mondo per creare viaggi significativi.",
    b2bPartnersList: "Collaboriamo con: comunità ebraiche, sinagoghe, rabbini, organizzazioni ebraiche, tour operator kosher e agenzie di viaggio nel mondo.",
    partnerBtn: "Collabora con noi",
    galleryTitle: "Galleria esperienze kosher",
    videosTitle: "Video in evidenza",
    ctaTitle: "Pronto a iniziare il tuo viaggio?",
    msgAllan: "Scrivi ad Allan su WhatsApp",
    callMorocco: "Chiama il Marocco: +212 6 63 63 05 79",
    ceoContact: "Parla direttamente con Allan Hatchuel su WhatsApp",
    exploreBtn: "Esplora i tour kosher"
  },
  aria: {
    openMenu: "Apri menu",
    closeMenu: "Chiudi menu",
    whatsappSocial: "WhatsApp",
    kosherTravel: "Viaggi kosher in Marocco",
    logoAlt: "Logo MoroccoLovesYou",
    kingAlt: "Re del Marocco",
    kosherOptionsAlt: "Opzioni kosher",
    jewishHeritageArchitecture: "Architettura del patrimonio ebraico",
    kosherMoroccanTable: "Tavola marocchina kosher",
    luxuryHospitality: "Ospitalità di lusso",
    kosherExperience: "Esperienza kosher",
    jewishHeritageMorocco: "Patrimonio ebraico in Marocco",
    kosherFoodMorocco: "Cibo kosher in Marocco",
    jewishHeritageExperience: "Esperienza del patrimonio ebraico"
  }
};

export default it;
